var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "telegram_svg__tgme_logo",
    viewBox: "5 5 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M7.065 16.926c5.228-2.107 8.713-3.495 10.457-4.166 4.98-1.916 6.015-2.249 6.69-2.26.148-.002.48.032.694.193.182.136.231.32.255.45.024.128.054.422.03.652-.27 2.623-1.437 8.987-2.031 11.924-.252 1.243-.75 1.509-1.23 1.55-1.04.088-1.828-.486-2.836-1.098-1.578-.956-2.533-1.398-4.065-2.332-1.77-1.079-.212-1.583.796-2.553.265-.253 4.776-4.31 4.756-4.431-.007-.045-.14-.482-.245-.568-.105-.086-.26-.057-.372-.033-.158.033-2.679 1.574-7.563 4.623-.716.455-1.364.676-1.945.665-.64-.013-1.872-.335-2.787-.61-1.123-.338-1.538-.497-1.46-1.07.04-.299.326-.61.856-.936z"
  })));
};
export default SvgTelegram;